// Typed-name signature check. An agent once countersigned an SOA with just
// "v" (hit Enter before finishing their name), which locked the document as
// complete with a meaningless signature (2026-10-30). The controller enforces
// the same rule.

export const MIN_SIGNATURE_LENGTH = 5;

/** '' if value looks like a full typed name (first and last), else a message. */
export function signatureProblem(value) {
  const name = String(value || '').trim().replace(/\s+/g, ' ');
  if (name.length < MIN_SIGNATURE_LENGTH || !name.includes(' ')) {
    return 'Please type your full name (first and last) as the signature.';
  }
  return '';
}
